import { useState } from 'react';
import { api, ApiError } from '../lib/api';
import { useToast } from '../context/ToastContext';

export function Receptions() {
  const toast = useToast();
  const [pm, setPm] = useState('');
  const [gm, setGm] = useState('');
  const [truck, setTruck] = useState('');
  const [ref, setRef] = useState('');
  const [msg, setMsg] = useState<{ text: string; err: boolean } | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    const quantities: Record<string, number> = {};
    if (+pm > 0) quantities.PM = +pm;
    if (+gm > 0) quantities.GM = +gm;
    if (!Object.keys(quantities).length) { setMsg({ text: 'Indiquez au moins une quantité.', err: true }); return; }
    if (!ref.trim()) { setMsg({ text: 'Indiquez la référence de la réception.', err: true }); return; }
    try {
      const r = await api<{ queued?: true }>('/v1/receptions', {
        method: 'POST', body: { quantities, truck: truck.trim(), ref: ref.trim() },
        offlineQueue: true, queueKind: 'reception',
        queueLabel: `Réception ${ref.trim()}${truck.trim() ? ' — ' + truck.trim() : ''}`,
      });
      if (r.queued) {
        setMsg({ text: 'Hors ligne — réception enregistrée, sera synchronisée automatiquement.', err: false });
        toast('Réception mise en attente (hors ligne)');
      } else {
        setMsg({ text: 'Réception enregistrée.', err: false });
        toast('Réception enregistrée');
      }
      setPm(''); setGm(''); setTruck(''); setRef('');
    } catch (e) { setMsg({ text: e instanceof ApiError ? e.message : 'Erreur', err: true }); }
  }

  return (
    <>
      <div className="pagehead"><h1>Réceptions</h1></div>
      <div className="card">
        <h2>Réception d'un camion (saisie manuelle)</h2>
        <form onSubmit={submit}>
          <div className="row2">
            <div><label>Quantité PM</label><input type="number" min={0} value={pm} onChange={(e) => setPm(e.target.value)} /></div>
            <div><label>Quantité GM</label><input type="number" min={0} value={gm} onChange={(e) => setGm(e.target.value)} /></div>
          </div>
          <label>Camion</label>
          <input value={truck} onChange={(e) => setTruck(e.target.value)} placeholder="ex. camion-12" />
          <label>Référence</label>
          <input value={ref} onChange={(e) => setRef(e.target.value)} required />
          <div className="row" style={{ marginTop: '0.8rem' }}><button type="submit" className="primary">Enregistrer la réception</button></div>
          {msg && <div className={msg.err ? 'err' : 'ok'}>{msg.text}</div>}
        </form>
      </div>
    </>
  );
}
